import React, { Component } from 'react';

import Header from './components/Header';
import { Outlet } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Separator from "@components/Separator";
import Footer from './components/Footer';
import styles from './respondentdashboard.module.css';


class RespondentDashboard extends Component {
  render() {
    return (
      <div>
        <div className={styles.dashboard_container}>
          <Sidebar />

          <div className={styles.dashboard_content}>
            <Header />

            <Outlet className={styles.dashboard_content} />
          </div>

        </div>

        <div style={{ margin: "15%" }} />
        <Separator size="100%" />
        <Footer />
      </div>

    )
  }
}

export default RespondentDashboard
